var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.confirmModal && _vm.showModal)?_c('ConfirmModal',{attrs:{"options":_vm.confirmModal,"cancel":_vm.cancelConfirmModal},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"d-flex flex-wrap justify-content-start align-items-center"},_vm._l((_vm.paths),function(ref){
var _id = ref._id;
var name = ref.name;
return _c('ofs-badge',{key:_id,staticClass:"mr-1 mb-1",attrs:{"text":name}})}),1)]},proxy:true}],null,false,550476243)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }